import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${light ? "text-[#FFB27A]" : "text-[#E05A00]"}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);
